"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loked = void 0;
const ApiException_1 = require("./ApiException");
class Loked extends ApiException_1.ApiException {
    constructor(message = 'Loked', data) {
        super(message, data);
    }
}
exports.Loked = Loked;
